module.exports = __webpack_public_path__ + "static/x50-4937758a8963fe56e1b025095607a0b0.png";